(() => {
  'use strict';
  const tag = 'qualuca-promo-allocation';
  if (customElements.get(tag)) return;
  const calendar = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Bucharest', year: 'numeric', month: 'numeric', day: 'numeric'
  });
  // Merchant's promotion rule: three packages per calendar day, including today.
  // A display of the stated promotion quota, not a Shopify inventory mutation.
  function allocationAt(date) {
    const parts = Object.fromEntries(calendar.formatToParts(date).map(p => [p.type, p.value]));
    const day = Number(parts.day);
    const days = new Date(Date.UTC(Number(parts.year), Number(parts.month), 0)).getUTCDate();
    return { quantity: (days - day + 1) * 3, capacity: days * 3 };
  }

  class PromoAllocation extends HTMLElement {
    connectedCallback() {
      if (this.timer) return;
      this.onVisibility = () => { if (!document.hidden) this.update(); };
      this.update();
      this.timer = setInterval(() => this.update(), 60000);
      document.addEventListener('visibilitychange', this.onVisibility);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.timer = null;
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
    update() {
      const count = this.querySelector('[data-qpa-count]');
      const meter = this.querySelector('[data-qpa-meter]');
      const fill = this.querySelector('[data-qpa-fill]');
      if (!count || !meter || !fill) return;
      const now = new Date();
      const { quantity, capacity } = allocationAt(now);
      this.setAttribute('data-qpa-tone', quantity < 25 ? 'red' : 'orange');
      count.textContent = String(quantity);
      meter.setAttribute('aria-valuemax', String(capacity));
      meter.setAttribute('aria-valuenow', String(quantity));
      meter.setAttribute('aria-valuetext', `${quantity} bucăți disponibile în limita promoției`);
      fill.style.width = `${quantity / capacity * 100}%`;
      this.hidden = false;
    }
  }
  customElements.define(tag, PromoAllocation);
})();
